import Image, { StaticImageData } from 'next/image'
import Link from 'next/link'

import jessicaAvatar from '../images/authors/JessicaFranks.jpeg'
import jonathanAvatar from '../images/authors/JonathanTalmi.jpeg'
import marcusAvatar from '../images/authors/MarcusWong.jpeg'

import seanAvatar from '../images/authors/SeanAbraham.jpeg'
import alexAvatar from '../images/authors/AlexGoodwin.jpeg'
import alanAvatar from '../images/authors/AlanCruickshank.jpeg'

import danAvatar from '../images/authors/DanCorcoran.jpeg'
import erikAvatar from '../images/authors/ErikWebb.jpeg'
import garrettAvatar from '../images/authors/GarrettMcClintock.jpeg'

import pamAvatar from '../images/authors/PamelaDalal.jpeg'
import aaronAvatar from '../images/authors/AaronSiegel.jpeg'
import garyAvatar from '../images/authors/GaryJames.jpeg'

export const danGoPuff = {
  content:
    'SELECT is a team favorite - its cost monitoring and auto savings give us peace of mind that our Snowflake spend is in check. The platform’s detailed insights across SQL queries, dbt, and Looker usage provides a comprehensive view into credit spend that is unmatched by other solutions. SELECT has helped us significantly optimize how we use Snowflake.',
  author: {
    name: 'Dan Corcoran',
    role: 'Senior Data Engineering Manager',
    image: danAvatar,
    company: 'Gopuff',
    linkedIn: 'https://www.linkedin.com/in/dan-corcoran-104626b3/',
  },
}

export const seanVideoAmp = {
  content:
    "SELECT's app has become an invaluable resource to our company. It clearly breaks down our costs to allow us to focus on the most important areas of cost. SELECT has repeatedly surfaced inefficient common query patterns, and has helped us spot 200 TiB of unused tables to drop, resulting in continued significant cost savings. SELECT is always adding new features to help their customers better understand and reduce their spending. We can't recommend them highly enough!",
  author: {
    name: 'Sean Abraham',
    role: 'Senior Principal Software Engineer',
    image: seanAvatar,
    company: 'VideoAmp',
    linkedIn: 'https://www.linkedin.com/in/seanabraham/',
  },
}

export const jessicaNoths = {
  content:
    'SELECT helps us quickly identify inefficient queries that consume unnecessary Snowflake credits, providing all the information we need in a single application. With the Automated Savings feature, we were able to allocate credits to new compute-intensive data projects.',
  author: {
    name: 'Jessica Franks',
    role: 'Data Engineering Manager',
    image: jessicaAvatar,
    company: 'Not On The High Street',
    linkedIn: 'https://www.linkedin.com/in/jessica-franks-za/',
  },
}

export const jonathanSuper = {
  content:
    'SELECT provides our team with complete visibility into all aspects of our Snowflake bill and usage. Our team regularly uses SELECT to monitor costs and get alerted on key changes. The dbt & Looker integrations are also super helpful for identifying performance bottlenecks.',
  author: {
    name: 'Jonathan Talmi',
    role: 'Senior Data Engineering Manager',
    image: jonathanAvatar,
    company: 'Super',
    linkedIn: 'https://www.linkedin.com/in/jonathan-talmi-1a099852/',
  },
}

export const garrettHeap = {
  content:
    'SELECT helped us monitor and reduce our overall Snowflake spend by almost 40%. The reporting showed me bottlenecks in minutes that would’ve otherwise taken weeks to dig through metadata and sort out. The Automated Savings savings feature alone is saving us over $10k a month across our accounts, allowing us to bring on new workloads.',
  author: {
    name: 'Garrett McClintock',
    role: 'Analytics Engineering Manager',
    image: garrettAvatar,
    company: 'Heap',
    linkedIn: 'https://www.linkedin.com/in/garrettmcclintock/',
  },
}

export const erikClair = {
  content:
    'Before SELECT, we were blind to our Snowflake cost drivers. Minutes after install, we identified a single job that was driving over 20% of our costs. The instant visibility & not having to build & maintain our own monitoring makes a big difference for a lean team like ours.',
  author: {
    name: 'Erik Webb',
    image: erikAvatar,
    role: 'Head of Data',
    company: 'Clair',
    linkedIn: 'https://www.linkedin.com/in/erik-gregory-webb/',
  },
}

export const pamSoftware = {
  content:
    'We love using SELECT to monitor our snowflake costs and usage. The interface drills down by warehouse, by integration, and surfaces cost anomalies at the query level so we can quickly identify and optimize our pipeline. The Automated Savings feature is easy to implement and pays for itself. This product is a perfect compliment to our Snowflake account.',
  author: {
    name: 'Pam Dalal',
    role: 'Head of Data',
    image: pamAvatar,
    company: 'Software.com',
    linkedIn: 'https://www.linkedin.com/in/pamdalal/',
  },
}

export const marcusClearco = {
  content:
    "We got up and running with SELECT in about 20 minutes and we're able to drop our usage by 15% in just two days, which freed up budget for other workloads. Our team was able to focus on other valuable business initiatives instead of worrying optimizing costs and building out our own monitoring. Awesome product!",
  author: {
    name: 'Marcus Wong',
    role: 'Director of Business Intelligence',
    image: marcusAvatar,
    linkedIn: 'https://www.linkedin.com/in/wongmarcus/',
  },
}

export const alexTheModernMilkman = {
  content:
    'SELECT has streamlined our data warehouse monitoring and reduced costs by 30%. Set up is quick and the reporting provides all the information we need to efficiently focus on where to make improvements, allowing the team to focus on building rather than having to worry about increasing costs. It has saved us a huge amount of time and money overnight!',
  author: {
    name: 'Alex Goodwin',
    role: 'Lead BI Developer',
    image: alexAvatar,
    company: 'The Modern Milkman',
    linkedIn: 'https://www.linkedin.com/in/alexander-g-71a2b2141/',
  },
}

export const alanTails = {
  content:
    "Setup for SELECT was swift and pain-free. Within 30 minutes we had a full view of our Snowflake usage and cost drivers, including a level of depth on our dbt project spend which we've struggled to get via other means. This helps us stay lean on our costs, without holding back innovation within the team.",
  author: {
    name: 'Alan Cruickshank',
    role: 'Head of Data & Insights',
    company: 'Tails.com',
    image: alanAvatar,
    linkedIn: 'https://www.linkedin.com/in/amcruickshank/',
  },
}

export const aaronChiliPiper = {
  content:
    "Engaging with SELECT was nothing short of transformative for our operations. Their fast and seamless integration effortlessly optimized our Snowflake warehouses, and we instantaneously reaped the benefits with a noticeable 20% reduction in our bill. But, it's not just about cost savings. SELECT's exceptional product stands as an invaluable tool for identifying costly query workloads, and it expertly guides us through efficient remediation processes. It's a must-have investment where the ROI isn't future promise — it's present fact.",
  author: {
    name: 'Aaron Siegel',
    role: 'Director of Data',
    company: 'Chili Piper',
    image: aaronAvatar,
    linkedIn: 'https://www.linkedin.com/in/aasiegel/',
  },
}

export const garyBeautyPie = {
  content:
    "Onboarding onto SELECT was quick and the instant insights made our spend management a lot more efficient. It's an absolute no-brainer to add to a Snowflake stack!",
  author: {
    name: 'Gary James',
    role: 'Senior Analytics Engineer',
    company: 'Beauty Pie',
    image: garyAvatar,
    linkedIn: 'https://www.linkedin.com/in/gary-james-013b0138/',
  },
}

const testimonials = [
  // column 1
  [danGoPuff, seanVideoAmp, jessicaNoths, jonathanSuper],
  // column 2
  [garrettHeap, erikClair, pamSoftware, marcusClearco],
  // column 3
  [alexTheModernMilkman, alanTails, aaronChiliPiper, garyBeautyPie],
]

interface Author {
  name: string;
  role: string;
  image: StaticImageData;
  company?: string;
  linkedIn: string;
}

interface Testimonial {
  content: string;
  author: Author;
}

interface QuoteIconProps extends React.SVGProps<SVGSVGElement> {}

export function QuoteIcon(props: QuoteIconProps) {
  return (
    <svg aria-hidden="true" viewBox="0 0 105 78" {...props}>
      <path d="M25.086 77.292c-4.821 0-9.115-1.205-12.882-3.616-3.767-2.561-6.78-6.102-9.04-10.622C1.054 58.534 0 53.411 0 47.686c0-5.273.904-10.396 2.712-15.368 1.959-4.972 4.746-9.567 8.362-13.786a59.042 59.042 0 0 1 12.43-11.3C28.325 3.917 33.599 1.507 39.324 0l11.074 13.786c-6.479 2.561-11.677 5.951-15.594 10.17-3.767 4.219-5.65 7.835-5.65 10.848 0 1.356.377 2.863 1.13 4.52.904 1.507 2.637 3.089 5.198 4.746 3.767 2.41 6.328 4.972 7.684 7.684 1.507 2.561 2.26 5.5 2.26 8.814 0 5.123-1.959 9.19-5.876 12.204-3.767 3.013-8.588 4.52-14.464 4.52Zm54.24 0c-4.821 0-9.115-1.205-12.882-3.616-3.767-2.561-6.78-6.102-9.04-10.622-2.11-4.52-3.164-9.643-3.164-15.368 0-5.273.904-10.396 2.712-15.368 1.959-4.972 4.746-9.567 8.362-13.786a59.042 59.042 0 0 1 12.43-11.3C82.565 3.917 87.839 1.507 93.564 0l11.074 13.786c-6.479 2.561-11.677 5.951-15.594 10.17-3.767 4.219-5.65 7.835-5.65 10.848 0 1.356.377 2.863 1.13 4.52.904 1.507 2.637 3.089 5.198 4.746 3.767 2.41 6.328 4.972 7.684 7.684 1.507 2.561 2.26 5.5 2.26 8.814 0 5.123-1.959 9.19-5.876 12.204-3.767 3.013-8.588 4.52-14.464 4.52Z" />
    </svg>
  )
}

export function Testimonial({ testimonial }: { testimonial: Testimonial }) {
  return (
    <figure className="relative rounded-2xl bg-gray-800 p-6 ">
      <QuoteIcon className="absolute left-6 top-6 h-8  fill-slate-700" />
      <blockquote className="relative">
        <p className="text-md font-medium tracking-tight text-white">
          {testimonial.content}
        </p>
      </blockquote>
      <Link
        href={testimonial.author.linkedIn}
        className="relative mt-6 flex items-center justify-between border-t border-slate-700 pt-6"
      >
        <div>
          <div className="font-display text-md text-white">
            {testimonial.author.name}
          </div>
          <div className="mt-1 text-sm font-semibold text-sky-400">
            {testimonial.author.role}
          </div>
          {testimonial.author.company && (
            <div className="font-display mt-1 text-sm text-white">
              {testimonial.author.company}
            </div>
          )}
        </div>
        <div className="overflow-hidden rounded-full bg-slate-50">
          <Image
            className="h-14 w-14 object-cover"
            src={testimonial.author.image}
            unoptimized
            alt=""
            width={56}
            height={56}
          />
        </div>
      </Link>
    </figure>
  )
}

export function Testimonials() {
  return (
    <section id="testimonials" aria-label="What our customers are saying">
      <ul
        role="list"
        className="mx-auto grid max-w-2xl grid-cols-1 gap-6 sm:gap-8 lg:max-w-none lg:grid-cols-3"
      >
        {testimonials.map((column, columnIndex) => (
          <li key={columnIndex}>
            <ul
              role="list"
              className="flex flex-col gap-y-6 text-start sm:gap-y-8"
            >
              {column.map((testimonial, testimonialIndex) => (
                <li key={testimonialIndex}>
                  <Testimonial testimonial={testimonial} />
                </li>
              ))}
            </ul>
          </li>
        ))}
      </ul>
    </section>
  )
}

import { ReactNode } from 'react';

export function TestimonialsContainer({ children }: { children: ReactNode }) {
  return (
    <>
      <div className="mx-auto max-w-4xl pb-6 md:text-center">
        <h2 className="mb-4 py-4 text-center text-3xl font-extrabold tracking-tight text-slate-200 sm:text-4xl">
          Hear <span className="border-b-4 border-sky-500">firsthand</span> from
          SELECT&apos;s users.
        </h2>
      </div>
      <div className="grid max-w-2xl grid-cols-1 items-center gap-4 lg:max-w-none lg:grid-cols-3">
        {children}
      </div>
    </>
  )
}
